import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { ISuiteAppGroup, SuiteService } from '@soleran/suite';
import { shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavSuiteResolver implements Resolve<ISuiteAppGroup[]> {
  constructor(private _ss: SuiteService) {}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this._ss.getGroups().pipe(shareReplay(1));
  }
}
